import { Action, createReducer, on } from '@ngrx/store';
import * as ordersActions from './orders.actions';
import { IQuotation } from '../../quotes/models/quotes.models';
import { IQuotationDetail } from '../models/quotes.models';
import * as quotesActions from '../../quotes/store/quotes.actions';
import { OrderFilter, refillOrderFilter } from 'src/app/shared/helper';

export interface OrdersFilterState {
  advanced: OrderFilter;
  keyword: string;
}
export interface ordersState {
  orders: IQuotation[];
  order: IQuotationDetail | null;
  loading: boolean;
  metadata: any;
  filters: OrdersFilterState;
}

export const initialordersState: ordersState = {
  orders: [],
  order: null,
  loading: false,
  metadata: null,
  filters: {
    advanced: refillOrderFilter(),
    keyword: '',
  },
};

const featureReducer = createReducer(
  initialordersState,
  on(ordersActions.GetOrdersSuccess, (state, action) => ({
    ...state,
    orders: action.resp.data,
    metadata: action.resp.metadata,
  })),
  on(ordersActions.GetOrderByIdSuccess, (state, action) => ({
    ...state,
    order: action.order,
  })),
  on(quotesActions.AcceptQuotationSuccess, (state, action) => ({
    ...state,
    order: { ...state.order, status: action.quotation.status! } as IQuotationDetail,
  })),
  on(ordersActions.Loading, (state, action) => ({ ...state, loading: action.loading })),
  on(ordersActions.SetOrderFilter, (state, action) => ({
    ...state,
    filters: {
      advanced: action.advanced!,
      keyword: action.keyword,
    },
  })),
  on(ordersActions.SetOrderSearch, (state, action) => ({
    ...state,
    filters: {
      ...state.filters,
      keyword: action.keyword,
    },
  })),

  // Update Order Actions - Update the main order state directly with full order response (includes gift products)
  on(ordersActions.UpdateOrderSuccess, (state, action) => ({
    ...state,
    order: action.order,
  })),

  // Local Order State Management - Update the main order state for local changes
  on(ordersActions.UpdateOrderState, (state, action) => ({
    ...state,
    order: state.order ? { ...state.order, ...action.updates } : null,
  }))
);

export function ordersReducer(state: ordersState | undefined, action: Action) {
  return featureReducer(state, action);
}
